import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

export interface UserDirectoryEntry {
  username: string;
}

export interface UserDirectoryResponse {
  users: UserDirectoryEntry[];
  total: number;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  landingAccess(accessToken: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = { accessToken: accessToken };

    return this.http.post(`${this.apiUrl}/access`, body, {
      headers: headers,
      withCredentials: true
    });
  }

  signin(username: string, email: string, password: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const body = {
      username: username,
      email: email,
      password: password
    };

    return this.http.post(`${this.apiUrl}/auth/signin`, body, {
      headers: headers,
      withCredentials: true
    });
  }

  requestAccess(email: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = {
      email: email
    };

    return this.http.post(`${this.apiUrl}/auth/access`, body, {
      headers: headers,
      withCredentials: true
    });
  }

  updateEmail(newEmail: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const options = {
      headers: headers,
      withCredentials: true
    };

    const body = {
      email: newEmail
    }

    return this.http.post(`${this.apiUrl}/auth/update-email`, body, options)
  }

  updatePassword(newPassword: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const options = {
      headers: headers,
      withCredentials: true
    };

    const body = {
      password: newPassword
    }

    return this.http.post(`${this.apiUrl}/auth/update-password`, body, options)
  }

  updateUsername(newUsername: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const options = {
      headers: headers,
      withCredentials: true
    };

    const body = {
      username: newUsername
    }

    return this.http.post(`${this.apiUrl}/auth/update-username`, body, options)
  }

  getCurrentUser(): Observable<any> {
    return this.http.get(`${this.apiUrl}/auth/get-user`, {
      withCredentials: true,
    });
  }

  getUserDirectory(): Observable<UserDirectoryResponse> {
    return this.http.get<UserDirectoryResponse>(`${this.apiUrl}/users`, {
      withCredentials: true,
    });
  }

  createNewUser(username: string, email: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const options = {
      headers: headers,
      withCredentials: true
    };

    const body = {
      username: username,
      email: email
    }

    return this.http.post(`${this.apiUrl}/auth/add-user`, body, options)
  }

  isUserAdmin(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.get<any>(`${this.apiUrl}/auth/is-admin`, options)
  }

  logout(): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/logout`, {}, { withCredentials: true });
  }

  verifyUser(): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/verify-user`, {}, { withCredentials: true });
  }

  shouldChangePassword(): Observable<any> {
    return this.http.get(`${this.apiUrl}/auth/should-change-password`, {
      withCredentials: true,
    });
  }

  deleteCurrentAccount(): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/delete-account`, {}, { withCredentials: true });
  }
}
